module.exports = __webpack_public_path__ + "img/dbf.79724e04.png";